import { SvgIcon } from "@mui/material";
import React from "react";

function PeopleIcon(props) {
  return (
    <SvgIcon viewBox="0 0 22 22" {...props}>
      <path
        d="M17.53 7.77C17.46 7.76 17.39 7.76 17.32 7.77C15.77 7.72 14.54 6.45 14.54 4.89C14.54 3.3 15.83 2 17.43 2C19.02 2 20.32 3.29 20.32 4.89C20.31 6.45 19.08 7.72 17.53 7.77Z"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M20.79 14.7C19.67 15.45 18.1 15.73 16.65 15.54C17.03 14.72 17.23 13.81 17.24 12.85C17.24 11.85 17.02 10.9 16.6 10.07C18.08 9.87001 19.65 10.15 20.78 10.9C22.36 11.94 22.36 13.65 20.79 14.7Z"  strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"/>
      <path d="M6.44003 7.77C6.51003 7.76 6.58003 7.76 6.65003 7.77C8.20003 7.72 9.43003 6.45 9.43003 4.89C9.43003 3.29 8.14003 2 6.54003 2C4.95003 2 3.66003 3.29 3.66003 4.89C3.66003 6.45 4.89003 7.72 6.44003 7.77Z"  strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"/>
      <path d="M6.55 12.85C6.55 13.82 6.76 14.74 7.14 15.57C5.73 15.72 4.26 15.42 3.18 14.71C1.6 13.66 1.6 11.95 3.18 10.9C4.25 10.18 5.76 9.89001 7.18 10.05C6.77 10.89 6.55 11.84 6.55 12.85Z"  strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"/>
      <path d="M12.12 15.87C12.04 15.86 11.95 15.86 11.86 15.87C10.02 15.81 8.55005 14.3 8.55005 12.44C8.56005 10.54 10.09 9 12 9C13.9 9 15.44 10.54 15.44 12.44C15.43 14.3 13.97 15.81 12.12 15.87Z"  strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"/>
      <path d="M8.87005 17.94C7.36005 18.95 7.36005 20.61 8.87005 21.61C10.59 22.76 13.41 22.76 15.1301 21.61C16.64 20.6 16.64 18.94 15.1301 17.94C13.42 16.79 10.6 16.79 8.87005 17.94Z"  strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"/>
    </SvgIcon>
  );
}

export default PeopleIcon;
